import constant from "../../constant";
import router from "../../router";
const api = constant.api + "stocks";

// initial state
const state = () => ({
  all: [],
  stocks: [],
  out_stocks: [],
  stock: {},
  stockFullNames: [],
  stockHistories: [],
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getStockFullNames: (state) => state.stockFullNames,
  getStockHistories: (state) => state.stockHistories,
  getStock: (state) => {
    return state.stock;
  },

  getStocks: (state) => {
    return state.stocks;
  },
  getChartData: (state) => {
    return {
      labels: state.stocks.map(({ item }) => item.fullName),
      datasets: [
        {
          data: state.stocks.map(({ quantity }) => quantity),
          backgroundColor: state.stocks.map(function (item) {
            var r = Math.floor(Math.random() * 256); // Random value between 0 and 255
            var g = Math.floor(Math.random() * 256);
            var b = Math.floor(Math.random() * 256);

            // Convert the RGB values to hexadecimal format
            var rHex = r.toString(16).padStart(2, "0"); // Convert to two-digit hex
            var gHex = g.toString(16).padStart(2, "0");
            var bHex = b.toString(16).padStart(2, "0");

            // Combine the hexadecimal values to form the color code
            var colorCode = "#" + rHex + gHex + bHex;

            return colorCode;
          }),
        },
      ],
    };
  },
  getOutStocks: (state) => {
    return state.out_stocks;
  },

  getRandomColorCode() {
    // Generate random values for the RGB components
    var r = Math.floor(Math.random() * 256); // Random value between 0 and 255
    var g = Math.floor(Math.random() * 256);
    var b = Math.floor(Math.random() * 256);

    // Convert the RGB values to hexadecimal format
    var rHex = r.toString(16).padStart(2, "0"); // Convert to two-digit hex
    var gHex = g.toString(16).padStart(2, "0");
    var bHex = b.toString(16).padStart(2, "0");

    // Combine the hexadecimal values to form the color code
    var colorCode = "#" + rHex + gHex + bHex;

    return colorCode;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const response = await this._vm.$api.instance.get(api);
    commit("setStocks", response.data);
  },
  async fetchStockFullNames({ commit }) {
    const response = await this._vm.$api.instance.get(`${api}_grouped`);
    commit("SET_SROCK_FULLNAMES", response.data);
  },

  async fetchStockHistories({ commit }, stockFullName) {
    const response = await this._vm.$api.instance.get(`${api}_histories`);
    commit("SET_SROCK_HISTORIES", response.data);
  },

  async filterStockHistories({ commit }, filter) {
    const response = await this._vm.$api.instance.post(
      `${api}_histories_filter`,
      filter
    );
    commit("SET_SROCK_HISTORIES", response.data);
  },
  async getAllOut({ commit }) {
    const response = await this._vm.$api.instance.get(`${api}_out`);
    commit("setOutStocks", response.data);
  },

  async show({ commit }, reference) {
    const response = await this._vm.$api.instance.get(`${api}/${reference}`);
    commit("setStock", response.data);
  },

  async store({ dispatch }, data) {
    const response = await this._vm.$api.instance.post(api, data);
    const message = response.data.message;
    const status = response.data.status;
    dispatch("notification/store", { status, message }, { root: true });
    if (status === "success") {
      router.push({ name: "stocks-index" });
    }
  },

  async update({ dispatch }, data) {
    const response = await this._vm.$api.instance.put(
      `${api}/${data.reference}`,
      data
    );
    const message = response.data.message;
    const status = response.data.status;
    if (status === "success") {
      router.push({ name: "stocks-index" });
    }
    dispatch("notification/store", { status, message }, { root: true });
  },

  async delete({ dispatch }, data) {
    const response = await this._vm.$api.instance.delete(
      `${api}/${data.reference}`
    );
    const message = response.data.message;
    const status = response.data.status;
    if (status === "success") {
      router.push({ name: "stocks-index" });
    }
    dispatch("notification/store", { status, message }, { root: true });
  },

  async print({ dispatch }, data) {
    dispatch(
      "notification/storeDownloading",
      {
        status: "success",
        message:
          "La fiche de stock actuelle est en téléchargement, Veuillez patienter...",
      },
      { root: true }
    );
    const response = await this._vm.$api.instance.post(
      `${api}_print_page`,
      data,
      {
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Stock.pdf");
    link.click();
  },

  async filter({ commit }, data) {
    const response = await this._vm.$api.instance.post(`${api}_filter`, data);
    commit("setStocks", response.data);
  },
  async transferQuantity({ dispatch }, data) {
    const response = await this._vm.$api.instance.post(
      `${api}_transfer_quantity`,
      data
    );
    const message = response.data.message;
    const status = response.data.status;
    dispatch("notification/store", { status, message }, { root: true });
    if (status === "success") {
      router.push({ name: "stocks-index" });
    }
  },
};

// mutations
const mutations = {
  setStocks(state, stocks) {
    state.all = stocks;
    state.stocks = stocks;
  },
  SET_SROCK_FULLNAMES(state, data) {
    state.stockFullNames = data;
  },
  SET_SROCK_HISTORIES(state, data) {
    state.stockHistories = data;
  },
  setOutStocks(state, out_stocks) {
    state.all = out_stocks;
    state.out_stocks = out_stocks;
  },
  setStock(state, stock) {
    state.stock = stock;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
